import { render, staticRenderFns } from "./SubscriptionsWidget.vue?vue&type=template&id=2ca6ace5&scoped=true&lang=pug"
import script from "./SubscriptionsWidget.vue?vue&type=script&lang=js"
export * from "./SubscriptionsWidget.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsWidget.vue?vue&type=style&index=0&id=2ca6ace5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6ace5",
  null
  
)

export default component.exports